import { render } from "./CIS-Latest-Insights-Item-Static.vue?vue&type=template&id=52757ff0"
import script from "./CIS-Latest-Insights-Item-Static.vue?vue&type=script&lang=js"
export * from "./CIS-Latest-Insights-Item-Static.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__